export enum HttpEventType {
  Sent = 0,                       // Indica que la solicitud HTTP ha sido enviada al servidor.
  UploadProgress = 1,             // Indica que se está progresando en la carga de archivos.
  ResponseHeader = 2,             // Indica que se han recibido los encabezados de la respuesta.
  DownloadProgress = 3,           // Indica que se está progresando en la descarga de archivos.
  Response = 4                    // Indica que se ha recibido una respuesta completa del servidor.
}
